import { Validators } from '@angular/forms';
import { 
	IFieldContainer, 
	IFieldDefinition, 
	IFormConfig, 
	InputTypes, 
	ValueTypes, 
	FieldViews 
} from 'app/interfaces';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	{
		key: 'unified_list_id',
		name: 'Listino',
		inputType: InputTypes.DATASET_SELECT,
		valueType: ValueTypes.REFERENCE,
		datasetCode: 'discount_rule_lists',
		remoteOptions: {
			limit: 100,
			getLabel(option): any{
				if(!option) return '';
				return '(' + option.code + ') ' + option.description;
			},
			getValue(option): any{
				if(!option) return;
				return option.id;
			},
			getDisplay(option): any{
				if(!option) return '';
				return '(' + option.code + ') ' + option.description;
			}
		},
		formValidators: [ Validators.required ]
	},
	{
		key: 'payment_type_id',
		name: 'Pagamento',
		inputType: InputTypes.DATASET_SELECT,
		valueType: ValueTypes.REFERENCE,
		datasetCode: 'payment_types',
		remoteOptions: {
			limit: 100,
			getLabel(option): any{
				if(!option) return '';
				return '(' + option.code + ') ' + option.descrizione;
			},
			getValue(option): any{
				if(!option) return;
				return option.id;
			},
			getDisplay(option): any{
				if(!option) return '';
				return '(' + option.code + ') ' + option.descrizione;
			}
		},
		formValidators: [ Validators.required ]
	}
];

const config: IFormConfig = { 
	title: 'Modifica Conferma',
	editTitle: 'Modifica Conferma',
	fields: formFields 
};

export default config;
